import { BooleanStatusDisplay } from "@/common/components/Status/BooleanStatusDisplay";
import { StatusDisplayProps } from "@/common/components/Status/StatusDisplay";
import { ApiEnumName } from "@/common/services/enum";
import { AvailabilityStatus } from "@/core/api/generated/v1";

import GeneralStatusEnumValueInline, {
  GeneralStatusEnumValueInlineProps,
} from "../GeneralStatusEnumValueInline";
import { AvailabilityStatusIndicator } from "./AvailabilityStatusIndicator";

interface Props {
  status: AvailabilityStatus | undefined;
  statusProps?: Partial<StatusDisplayProps>;
  enumInlineProps?: Partial<GeneralStatusEnumValueInlineProps>;
}

export function AvailabilityStatusDisplay({ status, statusProps, enumInlineProps }: Props) {
  return (
    <BooleanStatusDisplay
      value={null}
      statusProps={{
        title: (
          <GeneralStatusEnumValueInline
            statusEnumTypeName={ApiEnumName.AvailabilityStatus}
            status={status}
            {...enumInlineProps}
          />
        ),
        indicator: <AvailabilityStatusIndicator status={status} />,
        ...statusProps,
      }}
    />
  );
}
